export const usersData = [
  {
    key: "1",
    USER: "Andrew Simons",
    IMAGE: "avatar-20.jpg",
    PHONE: "+1 555 123 4567",
    EMAIL: "andrew@example.com",
    ROLE: "Admin",
    STATUS: "Active",
  },
  {
    key: "2",
    USER: "David Steiger",
    IMAGE: "avatar-21.jpg",
    PHONE: "+44 7911 123456",
    EMAIL: "david@example.com",
    ROLE: "Manager",
    STATUS: "Inactive",
  },
  {
    key: "3",
    USER: "Virginia Phu",
    IMAGE: "avatar-12.jpg",
    PHONE: "+33 612 345678",
    EMAIL: "phu@example.com",
    ROLE: "Customer",
    STATUS: "Active",
  },
  {
    key: "4",
    USER: "Walter Hartmann",
    IMAGE: "avatar-22.jpg",
    PHONE: "+61 412 345 678",
    EMAIL: "walter@example.com",
    ROLE: "Accountant",
    STATUS: "Active",
  },
  {
    key: "5",
    USER: "Andrea Jermaine",
    IMAGE: "avatar-27.jpg",
    PHONE: "+91 98765 43210",
    EMAIL: "jermaine@example.com",
    ROLE: "Inspector",
    STATUS: "Active",
  },
  {
    key: "6",
    USER: "Dennis Eckhardt",
    IMAGE: "avatar-05.jpg",
    PHONE: "+49 171 2345678",
    EMAIL: "dennis@example.com",
    ROLE: "Admin",
    STATUS: "Inactive",
  },
  {
    key: "7",
    USER: "Lan Adams",
    IMAGE: "avatar-25.jpg",
    PHONE: "+81 90 1234 5678",
    EMAIL: "lan@example.com",
    ROLE: "Manager",
    STATUS: "Inactive",
  },
  {
    key: "8",
    USER: "Ann Crump",
    IMAGE: "avatar-28.jpg",
    PHONE: "+34 612 345678",
    EMAIL: "crump@example.com",
    ROLE: "Customer",
    STATUS: "Active",
  },
  {
    key: "9",
    USER: "Julie Black",
    IMAGE: "avatar-07.jpg",
    PHONE: "+55 1987654321",
    EMAIL: "julie@example.com",
    ROLE: "Accountant",
    STATUS: "Active",
  },
  {
    key: "10",
    USER: "Jean Walker",
    IMAGE: "avatar-29.jpg",
    PHONE: "+27 82 12364567",
    EMAIL: "jean@example.com",
    ROLE: "Inspector",
    STATUS: "Active",
  },
];
